import React from 'react';
import TextFieldComp from '../TextFieldComp';

import IconButton from '@material-ui/core/IconButton';
// import TextField from '@material-ui/core/TextField';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';

// const useStyles = makeStyles((theme) => reserveBoxStyles(theme));

function QuickSearchToolbar(props) {
  // const classes = useStyles();

  return (
    <div
      style={{
        justifyContent: 'flex-end',
        display: 'flex',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        margin: 5,
      }}
    >
      <TextFieldComp
        compFrom="search"
        value={props.value}
        onChange={props.onChange}
        placeholder="Search…"
        // label="Search"
        // inputStyles={classes.specInputStyles}
        // className={classes.textField}
        InputProps={{
          startAdornment: <SearchIcon fontSize="small" />,
          endAdornment: (
            <IconButton
              title="Clear"
              aria-label="Clear"
              size="small"
              style={{ visibility: props.value ? 'visible' : 'hidden' }}
              onClick={props.clearSearch}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ),
        }}
      />
    </div>
  );
}

export default QuickSearchToolbar;
